const _snapshot = (function () {
    function Snapshot() {
        this.set = function (data) {
            const keys = Object.keys(data);
            const dataObjects = {};

            keys.forEach((key) => {
                if (data[key] instanceof Object) {
                    dataObjects[key] = data[key];
                }
            });

            return encodeURIComponent(JSON.stringify(dataObjects));
        };
    }

    return (props) => {
        return new Snapshot(props);
    };
})();

export default _snapshot;
